<template>
  <v-container fluid class="max-width">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Project Consumables</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/projects">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary style-14">
          <v-col cols="12" md="3">
            <v-autocomplete
              autocomplete="off"
              dense
              outlined
              v-model="selectedPhase"
              :items="phases"
              label="Select Phase"
              item-text="name"
              item-value="value"
              @change="fetchPhaseConsumables(selectedPhase)"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="3">
            <v-btn color="primary" text @click="addConsumableDialog = true">
              <v-icon left>mdi-plus</v-icon>Add Consumable Item
            </v-btn>
          </v-col>

          <v-col cols="12" md="6">
            <!-- <v-btn class="float-right" color="accent" text @click="generatePdf">
              <v-icon left>mdi-file-pdf-box</v-icon>Generate Requisition
            </v-btn>-->
            <!-- <iframe :src="pdfUrl" width="100%" height="500px"></iframe> -->
          </v-col>
          <v-col cols="12">
            <v-row dense class="pa-1">
              <v-col cols="6">Title:</v-col>
              <v-col cols="6">{{ project.name}}</v-col>

              <v-col cols="6">
                <span>Scale:</span>
              </v-col>
              <v-col cols="6">
                <span style>{{ project.projectScale && project.projectScale.Name }}</span>
              </v-col>

              <v-col cols="6">Project Lead:</v-col>
              <v-col cols="6">{{ project.lead && project.lead.name }}</v-col>

              <v-col cols="6">Start Date:</v-col>
              <v-col cols="6">{{ project.startDate | date }}</v-col>

              <v-col cols="6">Start Time</v-col>
              <v-col cols="6">{{ project.startTime }}</v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-divider class="mt-4 mb-4"></v-divider>

        <v-row class="mt-4 subtitle-2 text--primary">
          <v-col cols="12" v-for="(consumable, i) in projectConsumables" v-bind:key="i">
            <v-toolbar color="secondary" flat dense>
              <v-toolbar-title>{{ consumable.categoryName}}</v-toolbar-title>
            </v-toolbar>

            <v-data-table
              :items-per-page="2000"
              :headers="headers"
              :items="consumable.projectConsumables"
              hide-default-footer
            >
              <!-- total template -->
              <template
                v-slot:item.total="{ item }"
              >{{ (item.quantity * item.price).toLocaleString() }}</template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                
                <v-btn color="primary" text @click="editModal(item)">
                  <v-icon left>mdi-pencil</v-icon>Edit
                </v-btn>
              </template>

              <!-- action template -->
              <template v-slot:item.remove="{ item }">
                <v-btn color="red" text @click="removeModal(item)">
                  <v-icon left>mdi-close</v-icon>Delete
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- edit dialog -->
    <v-dialog v-model="editDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Edit Consumable</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="editDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <span
                  class="style-14"
                >Product: {{ consumableRecord.product && consumableRecord.product.Name }}</span>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  outlined
                  dense
                  label="Quantity"
                  v-model="consumableRecord.quantity"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  outlined
                  dense
                  label="Quantity"
                  v-model="consumableRecord.price"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <span
                  class="style-18"
                >Total: {{ (consumableRecord.quantity * consumableRecord.price).toLocaleString() }}</span>
              </v-col>

              <v-col cols="12">
                <v-btn color="primary" @click="updateRecord">
                  <v-icon left>mdi-content-save</v-icon>Update
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of edit modal-->

    <!-- consumable dialog -->
    <v-dialog v-model="addConsumableDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Add Consumable Item</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="addConsumableDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  autocomplete="off"
                  v-model="select"
                  :items="products"
                  :search-input.sync="searchProducts"
                  @change="setOrderItem(select)"
                  item-text="Name"
                  item-value="id"
                  cache-items
                  class="mt-2"
                  flat
                  hide-no-data
                  hide-details
                  label="Search Product"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>

              <v-col cols="6">
                <v-autocomplete
                  autocomplete="off"
                  v-model="selectedCategory"
                  :items="consumableCategories"
                  item-text="Name"
                  item-value="id"
                  cache-items
                  class="mt-2"
                  flat
                  hide-no-data
                  hide-details
                  label="Category"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  outlined
                  dense
                  label="Quantity"
                  v-model="requisitionItem.Quantity"
                ></v-text-field>
              </v-col>

              <v-col cols="6" xs="6" md="6">
                <v-text-field
                  autocomplete="off"
                  type="text"
                  name="goodsReceiptUom"
                  filled
                  outlined
                  readonly
                  dense
                  value="Unit(s)"
                  v-if="requisitionItem.ManualStatus == 'Y'"
                ></v-text-field>
                <v-autocomplete
                  autocomplete="off"
                  v-else
                  dense
                  outlined
                  single-line
                  v-model="requisitionItem.UomEntry"
                  :items="requisitionItem.ugp1"
                  label="UOM"
                  item-text="UomName"
                  item-value="UomId"
                  @change="uomChanged(requisitionItem)"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  outlined
                  dense
                  label="Price"
                  v-model="requisitionItem.BuyingPrice"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <span
                  class="style-18"
                >Total: {{ (requisitionItem.Quantity * requisitionItem.BuyingPrice).toLocaleString() }}</span>
              </v-col>

              <v-col cols="12">
                <v-btn color="primary" @click="addConsumable" :loader="loader" :disabled="loader">
                  <v-icon left>mdi-content-save</v-icon>Create Record
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of edit modal-->

    <!--  delete dialog -->
    <v-dialog v-model="removeDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Remove product from a project requisition</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="removeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <span
                  class="style-18"
                >Product: {{ consumableRecord.product && consumableRecord.product.Name }}</span>
              </v-col>

              <v-col cols="12">
                <v-btn
                  color="primary"
                  @click="removeConsumable"
                  :loader="loader"
                  :disabled="loader"
                >
                  <v-icon left>mdi-delete</v-icon>Remove
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of delete  modal-->

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>
  
  <script>
import { http, host } from "@/common/index";
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    TotalBill() {
      var qty = 0;

      if (this.record.Quantity) {
        qty = this.record.Quantity;
      }

      return qty * this.BuyingPrice;
    }
  },
  data: () => ({
    requisitionItem: {},
    pdfUrl: "",
    loader: false,
    selectedPhase: null,
    phases: [
      { name: "Phase 1", value: 1 },
      { name: "Phase 2", value: 2 },
      { name: "Phase 3", value: 3 },
      { name: "Phase 4", value: 4 }
    ],
    addConsumableDialog: false,
    record: {},
    editDialog: false,
    selectedProduct: null,
    removeDialog: false,
    Quantity: null,
    BuyingPrice: 0,
    SellingPrice: 0,
    consumableRecord: {},
    project: {},
    employees: [],
    projectEmployees: [],
    select: null,
    productId: null,
    selectedEmployee: null,
    selectedCategory: null,
    consumableCategories: [],
    projectConsumables: [],
    searchProducts: null,
    products: [],
    docCreate: true,
    headers: [
      { text: "Product", value: "product.Name" },
      { text: "Qty", value: "quantity" },
      { text: "Unit", value: "uom.UomName" },
      { text: "Price", value: "price" },
      { text: "Total", value: "total" },
      { text: "Phase", value: "phase" },
      { text: "Action", value: "action" },
      { text: "Remove", value: "remove" }
    ]
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true
    },
    searchProducts(val) {
      if (val && val !== this.selectedProduct && this.querySelections(val)) {
        this.querySelections(val);
      }
    }
  },
  methods: {
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      const data = {
        searchText: searchText
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData.length > 0) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setOrderItem(id) {
      const store_id = this.activeStore;
      // const self = this;
      // fetch the product from database
      this.$store
        .dispatch("get", `/products/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;
            // current item definition
            let currentItem = {};
            currentItem.Quantity = null;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.UomEntry = product.PUoMEntry;
            currentItem.o_i_t_m_s_id = id;
            currentItem.id = id;
            this.select = id;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            if (product.HasUom === 0) {
              // check if manual yes and assign
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.Price = buyingPrice;
              currentItem.currentPrice = buyingPrice;
              const total = 0;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = 0;

              this.select = null;
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.PUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.BuyingPrice = ugp1Record.BuyingPrice;
              currentItem.Price = ugp1Record.BuyingPrice;
              currentItem.currentPrice = ugp1Record.BuyingPrice;
              const total = 0;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = 0;
              //this.select = "";
              //self.products = [];
              // end of push
            }

            this.requisitionItem = { ...this.requisitionItem, ...currentItem };
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    addConsumable() {
      if (this.selectedCategory == undefined || this.selectedCategory == null) {
        this.$refs.snackbar.show("Please select a category", "red");
        return;
      }

      if (this.requisitionItem.id == undefined || this.requisitionItem.id == null) {
        this.$refs.snackbar.show("Please select a product", "red");
        return;
      }

      if (this.requisitionItem.Quantity == undefined || this.requisitionItem.Quantity == null) {
        this.$refs.snackbar.show("Please fill quantity", "red");
        return;
      }

      const self = this;

      var details = {
        productId: parseInt(self.requisitionItem.id),
        categoryId: parseInt(this.selectedCategory),
        quantity: parseFloat(self.requisitionItem.Quantity),
        UomEntry: parseInt(self.requisitionItem.UomEntry),
        price: parseFloat(self.requisitionItem.BuyingPrice),
        projectId: parseInt(this.$route.params.id)
      };

      const url = "/project-consumables";
      this.loader = true;
      this.$store
        .dispatch("post", { url, data: details })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.productId = null;
            self.selectedCategory = null;
            self.Quantity = null;
            self.BuyingPrice = null;
            self.addConsumableDialog = false;
            self.select = null;
            self.products = [];
            self.requisitionItem = {};
            self.fetchConsumables(self.$route.params.id);
            this.$refs.snackbar.show("Added successfully", "green");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.loader = false;
        });
    },
    editModal(item) {
      this.consumableRecord = item;
      this.editDialog = true;
    },
    removeModal(item) {
      this.consumableRecord = item;
      this.removeDialog = true;
    },
    removeConsumable() {
      const self = this;
      const url = `/project-consumables/${this.consumableRecord.id}`;
      self.loader = true;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.fetchConsumables(self.$route.params.id);
            self.removeDialog = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.loader = false;
        });
    },
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/projects/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.project = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });

      this.fetchConsumables(val);
    },
    fetchConsumables(id) {
      const self = this;
      this.$store
        .dispatch("get", `/project-consumables/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.projectConsumables = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    fetchPhaseConsumables(phase) {
      const self = this;
      const projectId = this.$route.params.id;
      this.$store
        .dispatch("get", `/project-consumables-phase/${projectId}/${phase}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.projectConsumables = res.ResponseData.consumables;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    save(data) {
      const url = "/projects";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push("/projects");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },

    updateRecord() {
      const url = `/project-consumables/${this.consumableRecord.id}`;
      const self = this;
      const data = {
        projectId: parseInt(this.consumableRecord.projectId),
        productId: parseInt(this.consumableRecord.productId),
        categoryId: parseInt(this.consumableRecord.categoryId),
        quantity: parseFloat(this.consumableRecord.quantity),
        price: parseFloat(this.consumableRecord.price),
        phase: parseInt(this.consumableRecord.phase)
      };

      self.loader = true;

      this.$store
        .dispatch("put", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.fetchConsumables(this.$route.params.id);
            self.editDialog = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.loader = false;
        });
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/consumable-categories`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.consumableCategories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    generatePdf() {
      var url = "/print-full-requisition/" + this.project.id;
      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    }
  },
  created() {
    this.getCategories();
  }
};
</script>